import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input, linkedSignal, output } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { DataAnalyticsTaggingConstants } from '../data-analytics-tagging/data-analytics-tagging.constants';
import { DataAnalyticsTaggingService } from '../data-analytics-tagging/data-analytics-tagging.service';
import { HelpDesktopComponent } from './help-desktop.component';
import { HelpMobileComponent } from './help-mobile.component';

@Component({
  selector: 'td-wb-help',
  templateUrl: 'help.component.html',
  styleUrls: ['help.component.scss'],
  imports: [
    HelpDesktopComponent,
    AsyncPipe,
    HelpMobileComponent
  ]
})
export class HelpComponent implements OnInit {
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly dataAnalyticsTaggingService = inject(DataAnalyticsTaggingService);

  readonly articleIdInput = input<string>(undefined, { alias: 'articleId' });
  readonly articleId = linkedSignal<string>(() => this.articleIdInput());
  readonly closeEvent = output<void>({ alias: 'close' });

  breakpointChanges$: Observable<BreakpointState>;

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM);
  }

  close(): void {
    this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.defaultModalCloseEvent);
    this.closeEvent.emit();
  }

  changeArticleId(event: string): void {
    if (this.articleId() !== event) {
      this.articleId.set(undefined);
    }
  }
}
